import html from "./LinkSurvey.html"
import "./SingleSurvey.css"
import "../SurveyCompletion/SurveyContainer.js"
import { knownTrackingParameters } from "../../../helpers/trackingParameters"
import { globalRequestHeaders } from "../../../api/getRequestHeaders"

$(document).ready(function () {
	if (!$(".link-survey-container").length) { return; }

	var model = JSON.parse(document.getElementById('AntiXssModelInit').textContent);

	var module = angular.module("LinkSurveyModule", ['CareEvWidgets', 'ngSanitize', 'ResearchKitApplicationModule', 'pascalprecht.translate', 'ngAria']);

	module
		.constant('WebViewStepFrameUrl', model.WebViewStepFrameUrl)
		.constant("availableLocales", model.AvailableLocales);

	let surveyReference;
	if (model.SurveyName) {
		surveyReference = { surveyName: model.SurveyName, linkIdentifier: model.LinkIdentifier };
	}
	else if (model.LinkKey) {
		surveyReference = { linkKey: model.LinkKey };
	}

	function inIframe() {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}

	module.component('linkSurvey', {
		template: html,
		controller: 'LinkSurveyController',
		controllerAs: 'vm'
	});

	module.controller("LinkSurveyController", ["$scope", "$translate",
		function ($scope, $translate) {
			$scope.embedded = inIframe();
			$scope.isWebKit = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.SurveyWindowInitialized ? true : false;
			if ($scope.embedded) {
				document.body.classList.add("embedded");
			}
			if ($scope.isWebKit) {
				document.body.classList.add("webkit");
			}

			// render at the beginning if turnstile is available, to ensure the widget is available to show by end of survey
			if (window.renderTurnstile) {
				window.renderTurnstile();
				$scope.$on('$destroy', function () {
					window.turnstile.remove();
				})
			}

			$scope.availableLanguageKeys = $translate.getAvailableLanguageKeys();
			var urlParams = new URLSearchParams(window.location.search);

			if (urlParams.has('lang') && $scope.availableLanguageKeys.indexOf(urlParams.get("lang")) != -1) {
				$translate.use(urlParams.get("lang")).then(function() {
					$scope.survey = surveyReference;
					globalRequestHeaders["Accept-Language"] = $translate.use() || $translate.proposedLanguage();
				});
			} else {
				$scope.survey = surveyReference;
				globalRequestHeaders["Accept-Language"] =  $translate.use() || $translate.proposedLanguage();
			}

			if ($scope.embedded) {
				window.parent.postMessage({ name: "SurveyWindowInitialized" }, '*');
			}
			else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.SurveyWindowInitialized) {
				window.webkit.messageHandlers.SurveyWindowInitialized.postMessage('*');
			}

			$scope.$on("surveyFinished", function (event, reason, taskResult, completionAction, followUp, linkIdentifier) {
				if ($scope.embedded) {
					window.parent.postMessage({ name: "SurveyFinished", reason: reason, taskResult: taskResult, linkIdentifier: linkIdentifier }, '*');
				}
				else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.SurveyFinished) {
					window.webkit.messageHandlers.SurveyFinished.postMessage({ reason: reason });
				}
				else {
					if (reason == 'Completed') {
						if (followUp) {
							$scope.followUp = true;
							handleFollowUp(followUp);
						} else {
							$scope.surveyComplete = true;
							$scope.survey = null;
						}
						$scope.$apply();
					} else if (reason == "Failed") {
						$scope.submitError = true;
						$scope.survey = null;
					}
					else if (reason == "Discarded") {
						$scope.surveyDiscarded = true;
						$scope.survey = null;
					} else if (reason) {
						$scope.errorReason = reason;
						$scope.survey = null;
					}
					else {
						$scope.surveyError = true;
						$scope.survey = null;
					}
				}
			});

			var setTrackingParameters = function (url, currentParams) {
				knownTrackingParameters.forEach(function (trackingParam) {
					if (currentParams.has(trackingParam)) {
						url.searchParams.set(trackingParam, urlParams.get(trackingParam));
					}
				});
			}

			var handleFollowUp = function (followUp) {
				if (!simpleUrlValidation(followUp)) {
					return;
				}
				var followUpUrl = new URL(followUp);
				setTrackingParameters(followUpUrl, urlParams)

				window.location = followUpUrl.href;
			}

			var simpleUrlValidation = function (proposedUrl) {
				if (proposedUrl.indexOf("data:") !== -1
					|| (proposedUrl.indexOf("javascript:") !== -1)
					|| (proposedUrl.indexOf("resource:") !== -1)
				) {
					return false;
				}
				return true;
			}

		}
	]);

	module.config(["$translateProvider", "translateConfigurationProvider", function ($translateProvider, translateConfigurationProvider) {

		translateConfigurationProvider.$get().configure($translateProvider, model.AvailableLocales);
	}]);

	angular.bootstrap($(".link-survey-container"), ["LinkSurveyModule"]);
});
